// http.js
import axios from 'axios';
import router from '@/router';
import store from '@/store/store.js';
import {
	Message
} from 'element-ui';
import md5 from 'js-md5';

let is = ''
if (process.env.NODE_ENV === 'development') {
	// 开发环境的代码
	is = 1
	console.log('当前是开发环境');
} else {
	// 生产环境的代码
	is = 2
	console.log('当前是生产环境');
}
const http = axios.create({
	// baseURL: is == 1 ? 'http://localhost:8080/' : '/', // 线上
	// baseURL: 'https://app.ydbooks.com/', // 线上
	// baseURL: 'http://2401717nh1.zicp.vip:9003/', // 本地
	// baseURL: 'http://192.168.1.203:8521/', // 本地
	baseURL: 'https://api.ydbooks.com/', // 测试服
	timeout: 20000, // 请求超时时间
	// 其他配置...
});

let host = 'youyidian99886121'
let set1 = ''



// 请求拦截
http.interceptors.request.use(
	config => {

		let token = localStorage.getItem('token')
		if (token) {
			let useInfo = JSON.parse(localStorage.getItem('useInfo')) || {}
			if (useInfo.accountType == 1) {// 学生
				if (router.currentRoute.meta && router.currentRoute.meta.module == 1) {
					router.push('/taotiziyuan')
					if (set1 == '') {
						console.log(10);
						set1 = setTimeout(item => {
							Message({
								type: 'error',
								message: `学生用户无浏览该页面权限`,
								onClose: () => {
									set1 = ''
								}
							})
						})
					}
					// return Promise.reject()
				}
			}
		}

		/**
		 * 生成签名
		 * @param {Object} sendmsg  
		 */
		let timestamp = Date.parse(new Date());
		let sendmsg = {}
		if (config.params) {
			sendmsg = config.params;
		}
		if (config.data) {
			sendmsg = config.data;
		}


		CalcuMD5(sendmsg, config.method.toUpperCase(), config.url, timestamp).then(res => {
			config.headers['clientType'] = `1`;
			config.headers['SIGN'] = res;
			config.headers['TIMESTAMP'] = timestamp;
			// 可以在这里添加例如token等请求头
			if (localStorage.getItem('token')) {
				config.headers['token'] = `${localStorage.getItem('token')}`;
			}
		})
		return config;
	},
	error => {
		// 请求错误处理
		return Promise.reject(error);
	}
);

// 响应拦截
http.interceptors.response.use(
	response => {
		const code = response.data.code || 200; //若未设置默认成功状态
		if (response.config.url == 'api/app/common/download') {
			if (code == 200) {
				const newUrl = response.request.responseURL;
				window.location.href = newUrl;
			}
		}
		if (code !== 0 && code !== 200) {
			console.log(9);
			if (set1 == '') {
				console.log(10);
				set1 = setTimeout(item => {
					Message({
						type: 'error',
						message: `${response.data.msg}`,
						onClose: () => {
							set1 = ''
						}
					})
				})
			}
			if (code == 401) {
				// 未登录
				localStorage.clear();
				store.commit('tabFn', 1)
				router.replace({
					path: 'login'
				})
			}
			return response.data
		} else {
			return response.data
		}
	},
	error => {
		// 响应错误处理
		Message.error(`服务暂不可用`);
		return Promise.reject(error);
	}
);
/**
 * 作者： TKE
 * 时间： 2019/12/17 0017
 * 功能：md5加密请求体
 * 描述：
 */
function CalcuMD5(obj, request_type, method, timestamp) {
	return new Promise(resolve => {
		// 如果不是对象  也就是说使用的GET和DELETE请求 那么不用加密  直接返回空

		let sign = ''
		if (request_type == 'GET') {
			method = ''
			let query1 = parseQueryString(method)
			if (Object.prototype.toString.call(obj) != '[object Object]') {
				// 如果不是对象
			} else {
				if (JSON.stringify(obj) === '{}') {
					// 如果空对象

				} else {
					// 如果对象有值
					Object.keys(obj).sort().forEach((k) => {
						if (obj[k] != undefined) {
							query1[k] = obj[k] !== undefined ? obj[k] : '';
						}
					})
					console.log(query1, 3333)
				}
			}
			query1["TIMESTAMP"] = timestamp
			let map = sortMapByKey(query1)
			for (const [key, value] of map) {
				sign += key
				sign += value
			}
		} else {
			sign += JSON.stringify(obj) + timestamp
		}
		resolve(md5(sign + host).toUpperCase());
	})
}

function parseQueryString(queryString) {
	// 去掉开头可能存在的 ? 号和路径部分
	queryString = queryString?.split('?')[1] || '';

	const params = {};
	if (!queryString) {
		return params;
	}

	// 分割参数对
	const pairs = queryString?.split('&');

	for (const pair of pairs) {
		const [key, value] = pair.split('=');
		if (key) {
			// 解码参数值，处理特殊字符
			params[decodeURIComponent(key)] = value ? decodeURIComponent(value) : '';
		}
	}

	return params;
}

function sortMapByKey(data) {
	// 创建 Map 并存储数据
	const map = new Map();

	// 添加数据
	Object.entries(data).forEach(([key, value]) => {
		map.set(key, value);
	});

	// 按key排序并返回新的 Map
	return new Map([...map.entries()].sort());
}

function randomn(n) {
	if (n > 21) return null
	var re = new RegExp("(\\d{" + n + "})(\\.|$)")
	var num = (Array(n - 1).join(0) + Math.pow(10, n) * Math.random()).match(re)[1]
	return num
}

export default http;